'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;

var _helpers = require('../common/helpers');

var _constants = require('./constants');

var lookupOperatingSystem = function lookupOperatingSystem(fingerprint) {
  var match = 'unknown';
  try {
    _constants.operatingSystems.forEach(function (_ref) {
      var name = _ref.name,
          pattern = _ref.pattern;

      if (pattern.test(fingerprint)) {
        match = name;
      }
    });
  } catch (err) {
    /* DO NOTHING */
  }
  return match.toLowerCase();
};

var get = exports.get = function get() {
  var staticProperties = {
    windowWidth: -1,
    windowHeight: -1,
    screenWidth: -1,
    screenHeight: -1,
    lastPageUrl: '',
    lastPageUrlCleaned: '',
    howOsDetailed: ''
  };

  if (window) {
    staticProperties.windowWidth = window.innerWidth;
    staticProperties.windowHeight = window.innerHeight;
  }

  if (navigator) {
    if (typeof navigator.appVersion === 'string') {
      staticProperties.howOsDetailed = lookupOperatingSystem((0, _helpers.between)(navigator.appVersion, '(', ')'));
    }
  }

  if (screen) {
    staticProperties.screenWidth = screen.width;
    staticProperties.screenHeight = screen.height;
  }

  if (document) {
    staticProperties.lastPageUrl = document.referrer;
    staticProperties.lastPageUrlCleaned = (0, _helpers.cleanUrl)(staticProperties.lastPageUrl);
  }

  return staticProperties;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/metaProperties/staticProperties.js
// module id = 1245
// module chunks = 3